import React, { useState, useEffect } from 'react';
import { Search, FileText, ExternalLink } from 'lucide-react';
import { authAxios } from '@/lib/api';
import SEOSettingsTab from './seo/SEOSettingsTab';
import RedirectsTab, { EMPTY_REDIRECT } from './seo/RedirectsTab';
import NotFoundTab from './seo/NotFoundTab';

const SUB_TABS = [
  { key: 'seo', label: 'SEO Settings', icon: Search },
  { key: 'redirects', label: 'Redirects', icon: ExternalLink },
  { key: 'errors', label: '404 Monitor', icon: FileText },
];

export default function SEOManager() {
  const [settings, setSettings] = useState([]);
  const [redirects, setRedirects] = useState([]);
  const [errors404, setErrors404] = useState([]);
  const [redirectDraft, setRedirectDraft] = useState(EMPTY_REDIRECT);
  const [activeTab, setActiveTab] = useState('seo');

  useEffect(() => {
    authAxios.get('/api/seo-settings').then(r => setSettings(r.data)).catch(() => {});
    authAxios.get('/api/redirects').then(r => setRedirects(r.data)).catch(() => {});
    authAxios.get('/api/errors/404').then(r => setErrors404(r.data)).catch(() => {});
  }, []);

  const clear404s = async () => {
    if (!window.confirm('Clear all 404 error logs?')) return;
    await authAxios.delete('/api/errors/404');
    setErrors404([]);
  };

  const redirectFrom404 = (path) => {
    setRedirectDraft({ from_path: path, to_path: '/', type: 301 });
    setActiveTab('redirects');
  };

  return (
    <div data-testid="seo-manager">
      <div className="flex gap-2 mb-6 border-b border-earth/10 pb-3">
        {SUB_TABS.map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-md text-xs font-sans font-semibold transition-colors ${activeTab === tab.key ? 'bg-saffron text-white' : 'text-earth/50 hover:bg-cream/50'}`}
            data-testid={`seo-tab-${tab.key}`}
          >
            <tab.icon size={13} /> {tab.label}
            {tab.key === 'errors' && errors404.length > 0 && <span className="ml-1 bg-red-500 text-white text-[9px] px-1.5 py-0.5 rounded-full">{errors404.length}</span>}
          </button>
        ))}
      </div>

      {activeTab === 'seo' && <SEOSettingsTab settings={settings} setSettings={setSettings} />}
      {activeTab === 'redirects' && <RedirectsTab redirects={redirects} setRedirects={setRedirects} draft={redirectDraft} setDraft={setRedirectDraft} />}
      {activeTab === 'errors' && <NotFoundTab errors={errors404} onClear={clear404s} onCreateRedirect={redirectFrom404} />}
    </div>
  );
}
